import { IApiEpBillingBill } from "@smp/api";
import { UiBox } from "@smp/ui";
import { useEffect } from "react";

import { useYakassa } from "@/hooks/use_yakassa";

export const Yakassa = ({
  bill,
  onDecline,
  onSuccess,
}: {
  bill: IApiEpBillingBill;
  onDecline: () => void;
  onSuccess?: () => void;
}) => {
  const { destroy, isLoaded, on, render } = useYakassa({
    confirmation_token: bill.extra.yoomoney_confirmation_token || "",
    error_callback: (error) => console.log(error),
    return_url: undefined,
  });

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    on("complete", () => {
      onSuccess?.();
      destroy();
    });

    on("fail", () => {
      onDecline();
    });

    render("yoo_money_widget");
  }, [destroy, isLoaded, on, render, onSuccess, onDecline]);

  return <UiBox id="yoo_money_widget" />;
};
